

































































import { DocumentActionsModel } from '@/types';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { DeviceHelper } from '@/mixins/deviceHelper';

export default Vue.extend({
  name: 'DocumentExportModal',
  mixins: [DeviceHelper],
  props: {
    showDocumentExportModal: {
      type: Boolean,
      required: true
    },
    document: {
      type: Object
    },
    isLoading: {
      type: Boolean
    }
  },
  data() {
    return {
      fileName: '',
      fileType: '',
      exportRelatedDocuments: false
    };
  },
  methods: {
    ...mapActions('relatedDocumentsStore', ['getRelatedDocuments']),
    async onSubmitAsync(this: any): Promise<void> {
      const isValid = await this.$refs.documentExportModalObserver.validate();
      if (!isValid) {
        return;
      }
      const exportDocumentModel = {
        export: true,
        exportRelatedDocuments: this.exportRelatedDocuments,
        relatedDocuments: this.relatedDocumentsModel.relatedDocuments
      } as DocumentActionsModel;
      this.$emit('Submit', exportDocumentModel, this.fileName);
    },
    closeExportDocumentModal(this: any): void {
      this.$emit('Cancel');
    }
  },
  computed: {
    ...mapGetters('relatedDocumentsStore', ['relatedDocumentsModel']),
    computeCheckBoxLabel(this: any): string {
      return this.document.inWorkflow ? 'Include related documents' : 'Include workflow and related documents';
    }
  },
  components: { MStoreForm, MStoreFormInput, MStoreFormCheckbox, LoadingSpinner },
  watch: {
    async showDocumentExportModal(this: any, newValue): Promise<void> {
      if (newValue) {
        this.fileName = this.document.fileName;
        this.fileType = this.document.fileExtension;
        this.exportRelatedDocuments = false;
      }
    }
  }
});
